// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../css-loader/index.js??ref--5-1!./message.css");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../../../vue-style-loader/lib/addStylesClient.js")("3a71ab37", content, true, {});


//////////////////
// WEBPACK FOOTER
// ./~/element-ui/lib/theme-chalk/message.css
// module id = 590
// module chunks = 8